import React, { useState } from "react";
import TextInputLabelHookForm from "../../../../../components/TextInputLabelHookForm";
import { useFormContext } from "react-hook-form";
import { editStateOfficeBMO } from "../atoms/atoms";
import { useRecoilValue } from "recoil";
import CheckBoxLabelHookForm from "components/CheckBoxLabelHookForm";
import { OfficeBMOType } from "../types";
import { permissionsSelector } from "modules/Login/selectors/permissionSelector";
import { PERMISSIONS } from "modules/PermissionsConstants";

const OfficeBMODetails = (props: {
  setChanges: React.Dispatch<React.SetStateAction<boolean>>;
  data: OfficeBMOType | undefined;
}) => {
  // Props drilled
  const { setChanges, data } = props;

  // Permission
  const userPermissions = useRecoilValue(permissionsSelector);
  const deletePermission = userPermissions.includes(
    PERMISSIONS.permission_utilities_officeconfiguration_officebmo_delete
  );

  // Recoil Hook
  const edit = useRecoilValue(editStateOfficeBMO);

  // Form Functions
  const { register } = useFormContext();
  const formMethods = useFormContext();

  // Local State
  const [inputData, setInputData] = useState(data?.bmoName || "");
  const [checkBoxChanges, setCheckBoxChanges] = useState(data?.isActive);

  // Event Handlers
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputData(e.target.value);
    if (
      e.target.value.trim() === "" ||
      (e.target.value === data?.bmoName && checkBoxChanges === data?.isActive)
    ) {
      setChanges(false);
    } else {
      setChanges(true);
    }
    e.target.value = e.target.value.replace(/\s+/g, " ");
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!deletePermission && data?.isActive) return;

    setCheckBoxChanges(e.target.checked);

    if (
      inputData?.trim() === "" ||
      (e.target.checked === data?.isActive && inputData === data?.bmoName)
    ) {
      setChanges(false);
    } else {
      setChanges(true);
    }
  };

  return (
    <div className="bg-bgDB">
      <div className="m-2 bg-white shadow-lg h-full">
        <div className="grid grid-cols-1 md:grid-cols-3 p-2 gap-2 place-items-center">
          <div className="px-1 mx-2 w-full">
            <TextInputLabelHookForm
              name="bmoName"
              label="BMO Name"
              type="text"
              onChange={(e) => {
                handleInputChange(e);
              }}
              required={true}
              className={
                formMethods.formState.errors.bmoName &&
                formMethods.formState.errors.bmoName.message &&
                "border-2 border-red-500 col-span-2 "
              }
              register={formMethods.register("bmoName", {
                required: {
                  value: true,
                  message: "Required Field",
                },
              })}
              maxLength={150}
            />
          </div>
          {edit && (
            <div className="px-3 mx-2 w-full">
              <CheckBoxLabelHookForm
                name="isActive"
                label={
                  checkBoxChanges
                    ? "Uncheck to Deactivate"
                    : "Check to Activate"
                }
                type="checkbox"
                validation={{
                  required: { value: false, message: "Required Field" },
                }}
                onClick={(e) => {
                  handleCheckboxChange(e);
                }}
                disabled={!deletePermission && data?.isActive ? true : false}
                register={register}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfficeBMODetails;
